import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, mergeMap, of } from 'rxjs'

import {show_error_action, show_success_msg_action} from '../action/common/common.action'
import { AutomationProcessListAPIModel, PaginatedAPI } from 'src/models/api.model'
import {
  FETCH_AUTOMATION_PROCESS_LIST,
  FETCH_AUTOMATION_PROCESS_LIST_SUCCESS, REPOST_FILE
} from '../action/automation-process-register.action'
import { AutomationProcessRegisterService } from 'src/services/automation-register/automation-register.service'

@Injectable()
export class AutomationProcessRegisterEffects {
  constructor(private actions$: Actions, private automationRegisterService: AutomationProcessRegisterService) {}

  fetch_payment_instructions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_AUTOMATION_PROCESS_LIST),
      mergeMap(action =>
        this.automationRegisterService.callFetchAutomationProcessRegisterApi(action.payload).pipe(
          mergeMap((response: PaginatedAPI<AutomationProcessListAPIModel>) => [
            FETCH_AUTOMATION_PROCESS_LIST_SUCCESS({ automationRegisterList: response })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  repost_file$ = createEffect(() =>
    this.actions$.pipe(
      ofType(REPOST_FILE),
      mergeMap(data =>
        this.automationRegisterService.invokeRepostFileAPI(data.id).pipe(
          mergeMap(() => [
            show_success_msg_action({
              msg: "File reposted successfully."
            })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
